import { render, staticRenderFns } from "./SectionRemarques.vue?vue&type=template&id=71730ebc&scoped=true&"
import script from "./SectionRemarques.vue?vue&type=script&lang=js&"
export * from "./SectionRemarques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71730ebc",
  null
  
)

export default component.exports